if (!window.__eaScriptsLoaded) {
  window.__eaScriptsLoaded = true;

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initFaq();
    initProductoGaleria();
    initProductoVariantes();
    initProductoComprar();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.ea-reveal, .ea-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('ea-visible'); });
    return;
  }
  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ea-visible');
          io.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { io.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.ea-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var btn = item.querySelector('.ea-faq-q');
    var answer = item.querySelector('.ea-faq-a');
    if (!btn || !answer) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('ea-open');
      item.closest('.ea-faq-list').querySelectorAll('.ea-faq-item.ea-open').forEach(function (open) {
        if (open !== item) {
          open.classList.remove('ea-open');
          open.querySelector('.ea-faq-a').style.maxHeight = null;
        }
      });
      if (isOpen) {
        item.classList.remove('ea-open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('ea-open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
}

function initProductoGaleria() {
  var wrap = document.querySelector('[data-ea-galeria]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-ea-galeria-main]');
  var thumbs = wrap.querySelectorAll('[data-ea-thumb]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-full');
      if (!src || !main) return;
      main.src = src;
      thumbs.forEach(function (t) { t.classList.remove('ea-active'); });
      thumb.classList.add('ea-active');
    });
  });
}

function initProductoVariantes() {
  var form = document.querySelector('[data-ea-producto-form]');
  if (!form) return;
  var dataEl = form.querySelector('[data-ea-variantes-json]');
  if (!dataEl) return;
  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-ea-precio]');
  var compareEl = document.querySelector('[data-ea-precio-comparado]');
  var buyBtn = form.querySelector('[data-ea-comprar]');
  var swatchGroups = form.querySelectorAll('[data-ea-option-index]');

  function seleccionActual() {
    var seleccion = [];
    swatchGroups.forEach(function (group) {
      var activo = group.querySelector('.ea-pd-swatch.ea-active');
      seleccion.push(activo ? activo.getAttribute('data-value') : null);
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = seleccionActual();
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (priceEl) priceEl.textContent = formatMoney(variante.price);
    if (compareEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        compareEl.textContent = formatMoney(variante.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (buyBtn) {
      buyBtn.disabled = !variante.available;
      buyBtn.textContent = variante.available ? buyBtn.getAttribute('data-label-disponible') : buyBtn.getAttribute('data-label-agotado');
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || 'es', { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR' });
  }

  swatchGroups.forEach(function (group) {
    group.querySelectorAll('.ea-pd-swatch').forEach(function (swatch) {
      swatch.addEventListener('click', function () {
        if (swatch.disabled) return;
        group.querySelectorAll('.ea-pd-swatch').forEach(function (s) { s.classList.remove('ea-active'); });
        swatch.classList.add('ea-active');
        actualizar();
      });
    });
  });
}

function initProductoComprar() {
  var form = document.querySelector('[data-ea-producto-form]');
  if (!form) return;
  var buyBtn = form.querySelector('[data-ea-comprar]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (buyBtn) buyBtn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) return Promise.reject();
        return response.json();
      })
      .then(function (item) {
        if (window.ttq) {
          ttq.track('AddToCart', {
            contents: [{
              content_id: String(item.product_id),
              content_type: 'product',
              content_name: item.product_title
            }],
            value: item.price / 100,
            currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'EUR'
          });
        }
        var opener = document.querySelector('pagepilot-cart-drawer-trigger button')
          || document.getElementById('cart-icon-bubble');
        if (opener) {
          opener.click();
          if (buyBtn) buyBtn.disabled = false;
        } else {
          window.location.href = '/cart';
        }
      })
      .catch(function () {
        form.submit();
      });
  });
}
